import React, { useEffect } from "react";

const RedirectPage = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const orderId = params.get("order_id");
    let appLink = ""
    if(orderId){
        appLink = `dinezi://orderconfirmation?orderId=${orderId}`;
    }else{
      appLink = `dinezi://home`;
    } 
    window.location.href = appLink;
  }, []);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #FF8C00, #4CAF50)", // orange → green
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "16px",
          padding: "40px",
          textAlign: "center",
          width: "400px",
          boxShadow: "0px 6px 20px rgba(0,0,0,0.2)",
        }}
      >
        {/* Spinner */}
        <div
          style={{
            width: "50px",
            height: "50px",
            margin: "0 auto 20px",
            border: "6px solid #eee",
            borderTop: "6px solid #FF8C00",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        />

        <h2 style={{ color: "#333", marginBottom: "10px" }}>
          Redirecting you back to <span style={{ color: "#FF8C00" }}>Dinezi</span> App...
        </h2>
        <p style={{ color: "#555", marginBottom: "20px" }}>
          Please wait while we take you back to the app.
        </p>

        <a
          href="dinezi://home"
          style={{
            display: "inline-block",
            background: "#4CAF50",
            color: "#fff",
            padding: "12px 24px",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "bold",
            transition: "background 0.3s",
          }}
          onMouseOver={(e) => (e.target.style.background = "#43a047")}
          onMouseOut={(e) => (e.target.style.background = "#4CAF50")}
        >
          Open App Manually
        </a>
      </div>

      {/* CSS animation keyframes */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default RedirectPage;
